export default "__VITE_ASSET__NXUobdO1__"